import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: '"Noto Sans KR", serif',
  },
});

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorker.unregister();

export { default as GasCostCalculator } from './pages/GasCostCalculator';
export { default as HappyCallSafety } from './pages/HappyCallSafety';
export { default as HappyCallIn } from './pages/HappyCallIn';
export { default as HappyCallOut } from './pages/HappyCallOut';
export { default as ApplyTalk } from './pages/ApplyTalk';